import { timing } from "./timing";
import type { PresentationRequest } from "./types";

export class PresentationQueue {
  private items: PresentationRequest[] = [];
  private seen = new Map<string, number>();
  constructor(private readonly limit = timing.queueLimit) {}

  enqueue(request: PresentationRequest, now = Date.now()): boolean {
    this.prune(now);
    const key = request.dedupeKey ?? request.id;
    if ((this.seen.get(key) ?? 0) > now) return false;
    this.seen.set(key, request.expiresAt ?? now + timing.itemCooldownMs);
    this.items.push(request);
    // Equal-priority requests are a sequence, not a stack. In particular,
    // moment-start effects must retain the order curated in Admin Tools.
    this.items.sort((a, b) => b.priority - a.priority || a.createdAt - b.createdAt);
    if (this.items.length > this.limit) this.items.length = this.limit;
    return true;
  }

  next(now = Date.now()): PresentationRequest | null { this.prune(now); return this.items.shift() ?? null; }
  remove(id: string): void { this.items = this.items.filter(item => item.id !== id); }
  get length(): number { return this.items.length; }
  snapshot(): readonly PresentationRequest[] { return this.items; }
  clear(): void { this.items = []; }
  private prune(now: number): void {
    this.items = this.items.filter(item => item.expiresAt === undefined || item.expiresAt > now);
    for (const [key, expiry] of this.seen) if (expiry <= now) this.seen.delete(key);
  }
}
